"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapPageElement = exports.wrapRootElement = void 0;

var _react = _interopRequireDefault(require("react"));

var _i18next = _interopRequireDefault(require("i18next"));

var _lodash = _interopRequireDefault(require("lodash.merge"));

var _reactI18next = require("react-i18next");

var _constants = require("./constants");

var _pageContext = require("./page-context");

const wrapRootElement = ({
  element
}, pluginOptions) => {
  const {
    i18nextConfig,
    defaultLanguage
  } = (0, _lodash.default)({}, _constants.DEFAULT_OPTIONS, pluginOptions);

  if (!i18nextConfig.resources) {
    throw new Error('You must specify where to load translations from through the `resources` field of `i18nextConfig`');
  }

  i18nextConfig.fallbackLng = defaultLanguage;

  _i18next.default.init(i18nextConfig);

  return /*#__PURE__*/_react.default.createElement(_reactI18next.I18nextProvider, {
    i18n: _i18next.default
  }, element);
};
/**
 * Wrap all pages with a Translation provider and set the language on SSR time
 */


exports.wrapRootElement = wrapRootElement;

const wrapPageElement = ({
  element,
  props
}, pluginOptions) => {
  const {
    supportedLanguages,
    excludedPages,
    defaultLanguage,
    siteUrl
  } = (0, _lodash.default)({}, _constants.DEFAULT_OPTIONS, pluginOptions); // if page should be excluded do nothing

  if (excludedPages.includes(props.location.pathname)) {
    return element;
  }

  const contextValue = (0, _lodash.default)({}, props.pageContext, {
    supportedLanguages,
    defaultLanguage,
    siteUrl
  }); // Can't wrap this in a React effect, since it won't work correctly. This changes
  // the context value (which causes React to re-render the page component).
  // Endless re-rendering from this circular dependency is prevented by the fact that Gatsby
  // doesn't call `wrapPageElement` more than once. If we didn't use Gatsby, `react-i18next` has
  // a helpful `useSSR` hook which uses an `isInitialized` boolean check to avoid calling the
  // `i18n.changeLanguage` more than once (i.e. not causing an endless circular dependency). See
  // more here:
  // https://github.com/i18next/react-i18next/blob/master/src/useSSR.js
  // -----
  // We know that this props will exist here because of @3nvi/gatsby-plugin-intl. Again, the
  // fallback has to do with the handling of non-localized pages (i.e. the original ones),
  // which exist only if `deleteOriginalPages` is `false`

  _i18next.default.changeLanguage(props.pageContext.lang || defaultLanguage);

  return /*#__PURE__*/_react.default.createElement(_pageContext.PageContext.Provider, {
    value: contextValue
  }, element);
};

exports.wrapPageElement = wrapPageElement;